import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { AddOutlined } from '@material-ui/icons';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useModalContextSubmissionSuccessful } from 'Hooks/useRefreshEvent';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

const styles = () => ({
  root: {},
});

const AddInsightsButton = ({
  resource,
}) => {
  const { refreshPageContentCollection } = usePageContentContext();
  const {
    setModalCollection,
    clearModalCollection,
  } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const onClick = async () => {
    try {
      const addInsightsColl = await resource.relationship(fr.relationships.addInsights.name).link('related').get();
      setModalCollection(addInsightsColl);
      logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'Scenario Insight - Add scenario insight button clicked');
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  useModalContextSubmissionSuccessful(() => {
    clearModalCollection();
    refreshPageContentCollection();
  }, [refreshPageContentCollection, clearModalCollection]);

  return (
    <IconButton
      onClick={onClick}
      color={'primary'}
      icon={AddOutlined}
      title={'Add Insights'}
      test={'facet-plan-add-insight-button'}
    />
  );
};

AddInsightsButton.defaultProps = {
};

AddInsightsButton.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddInsightsButton);
